import { css } from "@emotion/react";
import { ui } from "@joinlean/utils-react";

export const page = css`
  ${ui.column(120)};
  padding-bottom: ${ui.rem(150)};
`;
